<template>
  <div
    ref="drop"
    v-click-outside="closeEditor"
    :style="{
      top: coordinates.top,
      left: coordinates.left,
    }"
    :class="[$style.color_dropdown, dropToBottom ? '' : $style.dropdown_top]"
  >
    <vgp-colors-list
      :colors="paletteColors"
      :selected="colorPaletteSelected"
      @select-colors="onColorPaletteSelect"
    />
    <div
      v-if="value"
      :class="$style.reset_button"
      data-testid="gp_autotest_gantt_grid_color_reset_button"
      @click="unselect"
    >
      {{ locales('custom_column_recet_button_text') }}
    </div>
  </div>
</template>

<script>
import vgpColorsList from '$$uiKitComp/colorPalette/colorsList/colorsList.vue';
import globalStore from '$$globalStore';

export default {
  name: 'GridCustomListCellEditor',
  components: {
    vgpColorsList,
  },
  props: {
    data: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
  },
  emits: [
    'selectColors',
  ],
  data() {
    return {
      value: this.data ? +this.data : null,
      locales: __,
      coordinates: {
        left: 'auto',
        top: 'auto',
      },
      dropToBottom: true,
    };
  },
  computed: {
    paletteColors() {
      const teamColors = globalStore.getters['teamSetting/colors']?.data || [];
      const options = this.options || [];

      if (!options.length) {
        return teamColors;
      }

      return options.map(opt => {
        const hex = (opt.color || opt.value || '').trim();
        const teamColor = teamColors.find(c => (
          this.isSameHex(c.hex, hex)
          || (opt.colorId != null && Number(c.id) === Number(opt.colorId))
        ));

        if (teamColor) {
          return { ...teamColor, optionId: opt.id };
        }

        if (!hex) {
          return null;
        }

        return {
          id: opt.id,
          hex,
          hex2: hex,
          optionId: opt.id,
        };
      }).filter(Boolean);
    },

    colorPaletteSelected() {
      if (!this.value) {
        return [];
      }

      const option = (this.options || []).find(opt => String(opt.id) === String(this.value));

      if (!option) {
        return [];
      }

      const hex = (option.color || option.value || '').trim();

      return this.paletteColors.filter(c => this.isSameHex(c.hex, hex));
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getCoordinates();
    });
  },
  methods: {
    isSameHex(a, b) {
      if (!a || !b) {
        return false;
      }

      return a.trim().toLowerCase() === b.trim().toLowerCase();
    },

    onColorPaletteSelect(selected) {
      const color = selected[0];

      if (!color) {
        return;
      }

      const options = this.options || [];
      let option = null;

      if (color.optionId != null) {
        option = options.find(opt => String(opt.id) === String(color.optionId));
      }

      if (!option) {
        option = options.find(opt => (
          this.isSameHex(opt.color || opt.value, color.hex)
          || (opt.colorId != null && Number(opt.colorId) === Number(color.id))
        ));
      }

      if (option) {
        this.selectValue(option);
      }
    },

    unselect() {
      this.value = null;
      this.$emit('selectColors', '');
    },

    selectValue(item) {
      this.value = item.id;
      this.$emit('selectColors', this.value);
    },

    closeEditor() {
      this.$emit('selectColors', this.value ?? '');
    },

    getCoordinates() {
      const coordinates = this.placeholder.getBoundingClientRect();
      const clientHeight = document.documentElement.clientHeight;
      const elementHeight = this.$refs.drop.offsetHeight;

      this.dropToBottom = (coordinates.bottom + elementHeight) < clientHeight;

      if (this.dropToBottom) {
        this.coordinates = {
          top: `${coordinates.bottom + 1}px`,
          left: `${coordinates.left}px`,
        };
      } else {
        this.coordinates = {
          top: `${coordinates.top - elementHeight}px`,
          left: `${coordinates.left}px`,
        };
      }
    },
  },
};
</script>

<style module src="./colorPicker.less" lang="less"></style>
